import { useTranslation } from 'react-i18next';
import Title from '../Title.jsx';

const EmployeePolicy = () => {
  const { t } = useTranslation();

  const sections =
    t('employee_notice.employee_data.sections', { returnObjects: true }) || [];

  const appendixLabels = [
    'Appendix 1',
    'Annexe 1',
    'Apéndice 1',
    'Appendice 1',
  ];

  const contactLabels = [
    'How can you reach us?',
    'Comment nous contacter?',
    '¿Cómo puede contactarnos?',
    'Come puoi contattarci?',
  ];

  const isContact = (heading) =>
    contactLabels.some((label) => heading?.includes(label));

  const isAppendix = (heading) =>
    appendixLabels.some((label) => heading?.includes(label));

  const renderSectionTree = (section, index) => {
    if (!section) return null;

    return (
      <div key={section.id || index} className='text-primary-blue text-justify'>
        {section.heading && (
          <p className='py-2 text-lg lg:text-xl font-medium'>
            {section.heading}
          </p>
        )}

        {section.paragraphs?.map((para, paraIndex) => (
          <p
            key={paraIndex}
            className='text-lg lg:text-xl font-light'
            dangerouslySetInnerHTML={{ __html: para }}
          />
        ))}

        {section.items && (
          <ul className='list-disc'>
            {section.items.map((item, itemIndex) => (
              <li key={itemIndex} className='text-lg lg:text-xl font-light'>
                {item}
              </li>
            ))}
          </ul>
        )}

        {section.subSections?.map((subSection, subIndex) =>
          renderSectionTree(subSection, subIndex)
        )}
      </div>
    );
  };

  return (
    <div className='flex flex-col p-6 md:p-12 gap-6 md:gap-12 text-center max-w-[1600px] mx-auto w-full break-words'>
      <Title>{t('employee_notice.employee_data.title')}</Title>
      <p className='text-lg lg:text-xl font-light text-gray-500'>
        {t('employee_notice.employee_data.employee_subtitle')}
        <span className='font-medium text-primary-red'>Quantessence</span>{' '}
        {t('employee_notice.employee_data.employee_common')}{' '}
        {t('employee_notice.employee_data.employee_date')}
      </p>

      {sections.map((section, index) => {
        const contactSection = isContact(section.heading);

        return (
          <div
            key={section.id || index}
            className='w-full text-primary-blue text-justify'
          >
            <p className='text-xl lg:text-2xl font-medium'>{section.heading}</p>

            {section.paragraphs?.map((paragraph, paraIndex) => (
              <p
                key={paraIndex}
                className='py-2 text-lg lg:text-xl font-light'
                dangerouslySetInnerHTML={{ __html: paragraph }}
              />
            ))}

            {/* Contact Section */}
            {contactSection && section.contacts?.length >= 2 && (
              <div className='grid grid-cols-1 lg:grid-cols-2 py-4 text-lg lg:text-xl font-light'>
                {section.contacts.map((contact, idx) => (
                  <div key={idx} className='border rounded'>
                    <div className='p-2 text-lg lg:text-xl font-medium text-white bg-primary-red'>
                      {contact.branch}
                    </div>
                    <div className='p-2'>
                      {contact.entity}
                      <br />
                      <span className='font-medium'>{contact.officer}</span>
                      <br />
                      <br />
                      {contact.address}
                      <br />
                      <br />
                      email: {contact.email}
                    </div>
                  </div>
                ))}
              </div>
            )}
            {isAppendix(section.heading) && section.rows?.length > 0 && (
              <div className='py-4 text-lg lg:text-xl font-light'>
                <div className='hidden lg:grid grid-cols-2 p-2 font-medium text-white bg-primary-red'>
                  <div>{section.table?.[0]?.purpose_of_processing}</div>
                  <div>{section.table?.[0]?.nature_of_personal_data}</div>
                </div>
                <div className='flex flex-col'>
                  {section.rows.map((row, rowIndex) => (
                    <div
                      key={rowIndex}
                      className='grid grid-cols-1 lg:grid-cols-2 border rounded overflow-hidden'
                    >
                      <div className='flex flex-col justify-center border-x border-gray-300'>
                        <div className='lg:hidden p-2 font-medium text-white bg-primary-red'>
                          {section.table?.[0]?.purpose_of_processing}
                        </div>
                        <div className='p-2'>
                          <div>{row.purpose}</div>
                          {row.sub_purpose?.length > 0 && (
                            <div className='p-2'>
                              {row.sub_purpose.map((sub, subIndex) => (
                                <div key={subIndex}>{sub}</div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className='lg:hidden p-2 font-medium text-white bg-primary-red '>
                        {section.table?.[0]?.nature_of_personal_data}
                      </div>
                      <div className='p-2'>
                        {row.personalData.map((data, dataIndex) => (
                          <div
                            key={dataIndex}
                            dangerouslySetInnerHTML={{ __html: data }}
                          />
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {!contactSection &&
              section.subSections?.map((subSection, subIndex) =>
                renderSectionTree(subSection, subIndex)
              )}
          </div>
        );
      })}
    </div>
  );
};

export default EmployeePolicy;
